import script from "./BranchComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BranchComponent.vue?vue&type=script&setup=true&lang=js"

import "./BranchComponent.vue?vue&type=style&index=0&id=1d87133e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d87133e"]])

export default __exports__